<template>
  <div>
    <!-- 退出弹框 -->
    <modalDefault :showModal="showModal" @close="close()" @confirm="confirm()" modalText="消息列表" :showCancel="false"
      :showConfirm="false">
      <template #dialogContent>
        <div class="message-content">
          <div class="bt-game-desc" v-for="(item, index) in messageList" :key="index">
            <div style="color: #fff;font-size: 30rpx;font-family: 'Alimama ShuHeiTi', serif;">
              {{ item.message.slice(0, 6) }}
            </div>
            <span class="text-p" style="display: block; margin-top: 10rpx">
              {{ item.message }}
            </span>
            <div class="message-time">
              {{ item.sendTime }}
            </div>
          </div>
          <div class="no-data" style="margin-top: 5vh;" v-if="messageList.length == 0">
            <div class="empty-box-new"></div>
            <div class="tip-text">暂无信息</div>
          </div>
        </div>
      </template>
    </modalDefault>
  </div>
</template>
<script>
import { getMessageList } from "@/api/index";
import modalDefault from "@/components/common/modalDefault.vue";
export default {
  name: "modalMessage",
  components: {
    modalDefault,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.getMessageListFn();
      }
    },
  },
  data() {
    return {
      messageList: [
        {
          id: 1,
          message: "你好",
          status: 1,
          sendTime: "2021-07-07",
          readingTime: "2021-07-07",
        },
        {
          id: 1,
          message: "你好",
          status: 1,
          sendTime: "2021-07-07",
          readingTime: "2021-07-07",
        },
        {
          id: 1,
          message: "你好",
          status: 1,
          sendTime: "2021-07-07",
          readingTime: "2021-07-07",
        },
      ],
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm", this.code);
    },
    // 获取信息列表
    getMessageListFn() {
      getMessageList().then((res) => {
        this.messageList = res.data.rows;
        // console.log(this.messageList, "站内信");
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.bt-game-desc {
  margin: 15px;
  background-image: url("../../assets/images/win2_box_bg2.png");
  background-size: 100% 100%;
  background-repeat: repeat-x;
  position: relative;
  padding: 2 * 4, 2px 4 * 4, 2px;
  border-radius: 4px;
  text-align: left;
}

.bt-game-desc .text-p {
  line-height: 5.73 * 4, 2px;
  font-size: 3.33 * 4, 2px;
  color: #c7d4ff;
  margin: 0 0 6.67 * 4, 2px 0;
  text-align: left;
}

.message-content {
  width: 100%;
  height: 46 * 4.2px;
  overflow-y: auto;


  @media only screen and (max-width: 430px) {
    height: 46vw;
  }
}

.message-time {
  width: 100%;
  text-align: right;
  color: #fff;
  margin-bottom: 4px;
}

.noData {
  padding-top: 100px;
}

@media only screen and (max-width: 430px) {
  .message-time {
    margin-bottom: 1vw;
  }

  .bt-game-desc {
    margin: 30rpx;
    background-image: url("../../assets/images/win2_box_bg2.png");
    background-size: 100% 100%;
    background-repeat: repeat-x;
    position: relative;
    padding: 2vw 4vw;
  }

  .bt-game-desc .text-p {
    line-height: 5.73vw;
    font-size: 3.33vw;
    color: #c7d4ff;
    margin: 0 0 6.67vw 0;
  }
}
</style>